import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appScrollIntoView]',
  exportAs: 'scrollIntoView'
})
export class ScrollIntoViewDirective implements AfterContentInit {
  @Input('appScrollIntoViewDisabled') disabled?: boolean;


  constructor(private el: ElementRef) {
  }

  ngAfterContentInit() {
    setTimeout(() => {
      this.scrollToElement();
    });
  }

  scrollToElement() {
    try {
      this.el.nativeElement.scrollIntoViewIfNeeded();
    } catch { }
  }

}
